var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlcoholAssortment = function SvgAlcoholAssortment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2h2.4v1.4H15zM14.4 4H18v2.4l.8 1.7V20a1 1 0 0 1-1 1h-3.2a1 1 0 0 1-1-1V8.1l.8-1.7zM3.5 4h6.2l-.45 3.2A3.5 3.5 0 0 1 7 10.1V19h2a1 1 0 1 1 0 2H4.2a1 1 0 1 1 0-2h2v-8.9a3.5 3.5 0 0 1-2.25-2.9z"
  })));
};
export default SvgAlcoholAssortment;